import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link, useParams } from "react-router-dom"
// import { selectScopedByClient } from "../../stores/appSlice"

export default function AdminReportNav({ activeTab }) {
    const dispatch = useDispatch()
    const { clientId } = useParams()
    // const scopedByClient = useSelector(selectScopedByClient)

    // Fetch the division we need for breadcrumb
    // TODO: we may be able to simply swap this out for the use selector based
    // on how we decide to finally load in the records from other components.
    // useEffect(() => {
    //     if (divisionId) {
    //         dispatch(fetchDivision(divisionId))
    //     }
    // }, [dispatch, divisionId])

    const formatRoute = (newRoute) => {
        return `/clients/${clientId}/reports${newRoute}`
    }

    const renderIndexHeader = () => {
        return (
            <>
                <h2>Reports</h2>
                {/* <ul className="header-tab-nav" role="navigation">
                    <li>
                        <Link to={() => formatRoute("/dashboard")}>
                            <button type="link" className={`${activeTab === "dashboard" ? "selected" : ""}`}>
                                Reports Dashboard
                            </button>
                        </Link>
                    </li>
                </ul> */}
            </>
        )
    }

    return <>{renderIndexHeader()}</>
}
